export default __webpack_public_path__ + "static/media/Vector4.15ceb73b.svg";